Customer.Dashboard ||= {}

class Customer.Dashboard.TicketResponseView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/response']
  templateWebchat: JST['backbone/templates/customer/ticket/body/response_webchat']

  className: 'clearfix response-box-wrapper'

  events:
    'click #cancel': 'onCancel'
    'click .send_response': 'onClickReply'
    'click .send_response_and_close': 'onClickReplyAndClose'
    'click .send_response_and_change_to_pending': 'onClickReplyAndChangeToPending'
    'click button[value="private"]': 'onPrivate'
    'click button[value="public"]': 'onPublic'
    'input #response': 'countChars'
    'click #predefined-answers-btn': 'showResponseTemplates'
    'click #expand-response-btn': 'onExpand'
    'click #reply': 'reply'
    'click #forward': 'forward'
    'click .add_emoji': 'onToggleEmojis'
    'click .shorten_links' : 'shortenLinks'
    'click #add-signature': 'addSignature'
    'click #close-webchat': 'closeWebchat'
    'click .open-response-schedule': 'openResponseSchedule'
    'change .suggest-private-message': '_updateCharacterCountAndLimit'

  #Define here integrations that use the new actions delegator strategy. #TODO: implement strategy pattern in coffee
  new_actions_strategy_types = ['google_play', 'apple_app_store', 'whatsapp', 'webchat']

  initialize: (@options = {}) ->
    @ticketView = @options.ticketView
    @ticket = @ticketView.model
    @listenToOnce(@ticket, 'response:success', @_handleResponseSuccess)
    @listenTo(@ticket, 'response:error', @_handleResponseError)
    @listenTo(@ticket, 'response:staleDialogue', @_handleResponseStaleDialogue)
    @listenTo(@ticket, 'change:can_reply', @render)
    @listenTo @ticket, 'action:follow', => @_handleFollow(true)
    @listenTo(@ticket, 'close_webchat:success', @onResponseDisabled )
    @responseTo = @options.responseTo
    @responseText = @_initialResponseTextWithSignature(@options.responseText)
    @isPrivate = @options.isPrivate
    @mentionsString = ''
    @textLimit = ''

  onDetach: ->
    # nothing to do here

  onAttach: ->
    # nothing to do here

  render: =>
    @renderTemplate()
    @renderResponseBox()
    @

  renderResponseBox: ->
    @loadPredefinedTemplatesBtn()
    afterRender = =>
      @_responseTextArea().focus()
      @setTextLimits()
      @_initializeSocialAccountsChosen()
    setTimeout(afterRender, 300)

    @_renderAttachments()
    @$el.find('.suggest-private-message-checkbox-container').hide()
    @onPublic() if !@isPrivate

    @_responseTextArea().text(@responseText)
    @setCaretAtLastOfResponse() unless @ticket.isEmail()
    @_setInputAsEmojiable()
    @

  _renderAttachments: ->
    if @canAddAttachments()
      if @ticket.type() == 'email'
        unless @attachment
          @attachment = new Customer.Ticket.ResponseAttachmentView(@$el.find('.attachment-uploader'), @, @ticket.subType())
          @attachment.render()
      else
        @attachment = new Customer.Ticket.ResponseAttachmentView(@$el.find('.attachment-uploader'), @, @ticket.subType())
        if @ticket.isWhatsapp()
          @attachment = new Customer.Ticket.WhatsappResponseAttachmentView(@$el.find('.attachment-uploader'), @, @ticket.subType())
          @listenTo @attachment, 'add:document:disableTextArea', @_disableResponseTextArea
          @listenTo @attachment, 'remove:document:enableTextArea', @_enableResponseTextArea
          @listenTo @attachment, 'error:document:enableTextArea', @_enableResponseTextArea
        @attachment.render()
    if @canSendPictures()
      if @ticket.isTwitter()
        @attachment = new Customer.Conversation.Attachments.TwitterAttachmentsView(
            el: @$el.find('#image-uploader')
            previewsContainer: @$el.find('#direct-attachments-previews-container')
            attachmentLimit: if @ticket.subType() == 'tweet' then 4 else 1
          )
        @attachment.render()
      else
        @attachment = new Customer.Conversation.ResponseImageView(@$el.find('#image-uploader'), @)
        @attachment.render()

  _initializeSocialAccountsChosen: ->
    unless @$el.find('#social_accounts').hasClass('hidden')
      @$el.find('#social_accounts').chosen()
      @$el.find('#social_accounts').on('chosen:showing_dropdown', (event) ->
        chosen_container = $(event.target).next('.chosen-container')
        dropdown = chosen_container.find('.chosen-drop')
        dropdown_top = dropdown.offset().top - $(window).scrollTop()
        dropdown_height = dropdown.height()
        viewport_height = $(window).height()

        chosen_container.addClass('chosen-drop-up') if dropdown_top + dropdown_height > viewport_height
      )
    @$el.find('#social_accounts').on('chosen:hiding_dropdown', (event) ->
      $(event.target).next('.chosen-container').removeClass('chosen-drop-up')
    )

  onAttachmentLoading: ->
    @suspendedText = @_responseTextArea().val()
    @_responseTextArea().val('')
    @_disableResponse()

  onAttachmentDone: ->
    @_responseTextArea().val(@suspendedText) if @suspendedText
    @suspendedText = ''
    @_enableResponse()

  _responseHasParticipants: ->
    @$el.find('button[value="public"].active').get(0) || @ticket.isInstagramPublic()

  _getParamsToRender: ->
    jsonModel = @ticket.toJSON()
    showSocialAccountsCombo = @_getInteractionToResponse().get('social_accounts_combo_visible')

    if _.last(@ticket.interactions())
      responseTo = _.last(@ticket.interactions()).get('interaction_id')
    else
      responseTo = @ticket.distinguished_content.get('interaction_id')

    model: jsonModel,
    socialAccounts: @_getSocialAccounts(),
    showSocialAccountsCombo: showSocialAccountsCombo,
    responseText: @responseText,
    publicReplyEnabled: !@isPrivate,
    privateReplyEnabled: @isPrivate,
    options: @options,
    isPrivate: @isPrivate,
    count: @_predefinedAnswersCount()
    attachments: @canAddAttachments()
    pictures: @canSendPictures()
    responseTo: responseTo

  _getSocialAccounts: ->
    interaction = @_getInteractionToResponse()
    return interaction.get('social_accounts')

  _predefinedAnswersCount: ->
    collection = Customer.ResponseTemplateCollection.getExpandedCollection()
    tags = @_userTagsAndLabels().tags || []
    return 0 if tags.length == 0 || !collection.labels
    collection.getModelsMatching(
      {list: tags, include_global: false, any: false},
      {list: @_userTagsAndLabels().labels, include_global: true, any: false},
      @_userTagsAndLabels().typeForResponseTemplates, true).length

  loadPredefinedTemplatesBtn: ->
    count = @_predefinedAnswersCount()
    text = '<span> ' + I18n.t('customer.dashboard.conversations.details.response.predefined_answers.header') + ' </span>'
    if count > 0
      text = '<div class="indicator"></div><b>' + count + '</b>' + text
    @$el.find('#predefined-answers-btn').html(text)

  onPublic: =>
    @_keepCustomerSessionAlive()
    @$el.find('.suggest-private-message-checkbox-container').show()
    @isPrivate = false
    @_addParticipantsToResponse() if @_shouldShowParticipants()
    @_updateCharacterCountAndLimit()
    $response = @_responseTextArea()
    $response.removeAttr('maxlength')

  _addParticipantsToResponse: ->
    $response = @_responseTextArea()
    return unless $response.get(0) and @hasParticipants(@responseTo)
    ownChannels = _.pluck(@ticketView.options.channels, 'name')
    participantsToMention = _.difference(_.compact(@ticket.participants()), ownChannels)
    @mentionsString = ("@#{participant} " for participant in participantsToMention).join('')
    return if @_mentionsAlreadyPresent()
    $response.val("#{@mentionsString}#{$response.val()}")

  _mentionsAlreadyPresent: ->
    @_responseTextArea().val().indexOf(@mentionsString) is 0

  _removeParticipantsFromResponse: ($response) ->
    $response.val($response.val().replace(@mentionsString, ''))

  _updateCharacterCountAndLimit: ->
    @setTextLimits()
    @countChars()

  setTextLimits: =>
    @textLimit = if @isPrivate then @ticket.privateTextLimit() else @ticket.publicTextLimit()
    return unless @textLimit?
    @textLimit = @textLimit - 23 if @$el.find('.suggest-private-message').is(':visible:checked')
    @$el.find('#current_maxlength').text "/#{@textLimit}"

  countChars: =>
    @_keepCustomerSessionAlive()
    responseLength = Array.from(@_responseTextArea().val() || '').length
    @onOperatorIsTyping() if responseLength > 0
    @$el.find('#current_amount').text(responseLength)
    limitExceeded = @textLimit? and responseLength > @textLimit
    @$el.find('#character-count').toggleClass('warning', limitExceeded)
    @$el.find('.reply-button button').add('.open-response-schedule').prop('disabled', limitExceeded)
    @_grabResponseText()

  _grabResponseText: ->
    @responseText = @_responseTextArea().val() || ''
    @_deleteResponseTextFooter()

  _deleteResponseTextFooter: ->
    indexOfFooter = @responseText.indexOf '\n---------- Forwarded message ----------'
    return if indexOfFooter is -1
    @responseText = @responseText.substring(0, indexOfFooter)

  onPrivate: =>
    @_keepCustomerSessionAlive()
    @$el.find('.suggest-private-message-checkbox-container').hide()
    if @ticket.isTwitter()
      @tryPrivate()
    else
      @onPrivateSuccessful()

  tryPrivate: =>
    $buttons = @$el.find('.btn-group button').prop('disabled', true)
    $.ajax
      url: '/customer/ticket/can_send_twitter_dm'
      type: 'POST'
      cache: false
      contentType: false
      processData: false
      data: @_paramsToResponse(undefined, undefined, 'private')
      success: (response) =>
        @$el.find('.btn-group button[value="public"]').prop('disabled', false) if !@isPrivate
        @$el.find('.btn-group button[value="private"]').prop('disabled', false) if @isPrivate
        if response.success
          @onPrivateSuccessful()
        else
          showError(message) for message in response.messages
          @$el.find('.btn-group button[value="public"]').click()
      error: =>
        @isPrivate = false
        $buttons.prop('disabled', false)
        showError I18n.t('generic_error_message')
        @$el.find('.btn-group button[value="public"]').click()

  onPrivateSuccessful: =>
    @isPrivate = true
    $response = @_responseTextArea()
    @$el.find('.btn-private-send').addClass('active')
    @$el.find('.btn-public-send').removeClass('active')
    @$el.find('.btn-group button[value="private"]').prop('disabled', false) if @isPrivate
    $response.removeAttr('maxlength')
    return unless $response.get(0)
    @_removeParticipantsFromResponse($response)
    participants = @ticket.participants()
    if @ticket.isTwitter() && $response.val().indexOf(participants) == 0
      $response.val($response.val().substring(participants.length))
    @_updateCharacterCountAndLimit()

  onSaveNote: =>
    content = @$el.find('#note_text').val()
    @trigger('note:saved', content) if content != ''
    @$el.find('#note_text').val('')

  onCancel: =>
    @attachment.restoreDefaultAttachments(@_getInteractionToResponse()) if @ticket.isEmail()
    @_keepCustomerSessionAlive()
    @trigger('onHide')
    false

  _getActiveButtonFrom: ($buttons) ->
    button = _.find($buttons, (button) -> $(button).hasClass('active'))
    $(button)

  _doesNotMatchAccount: ->
    filtered = _.filter(@ticketView.options.socialAccounts, (account) =>
      if @ticket.subType() == "ig-message"
        account.provider == "instagram-dm"
      else
        ((account.provider == 'instagram') && (@ticket.type().substring(0, 9) == 'instagram')) || @ticket.type() == account.provider
    )
    filtered.length > 0 && @emptySocialAccount()

  emptySocialAccount: ->
    _.string.isBlank(@$el.find('#social_accounts').val())

  _checkMatchingAccount: ->
    if @_doesNotMatchAccount()
      throw new Error("#{I18n.t('customer.dashboard.conversations.details.response.does_not_match')}")

  _checkEmptySocialAccount: ->
    if @emptySocialAccount()
      throw new Error("#{I18n.t('customer.dashboard.conversations.details.response.need_account')} #{@ticket.type().toUpperCase()} #{I18n.t('customer.dashboard.conversations.details.response.before')} #{@$el.find('button.send_response_and_close').text()}")

  _checkValidForwardRecipients: ->
    recipients = @$el.find('#input_send_to').val()
    if _.string.isBlank(recipients)
      throw new Error('Empty recipients')
    else if not @forwardRecipientsValid(recipients)
      throw new Error('Please enter valid forward recipients')

  _checkValidResponse: ->
    response = @_responseTextArea().val()
    action = @_getActiveButtonFrom(@$el.find('.btn_send_response'))
    unless action && @hasEnoughData(response)
      throw new Error('Response text is not enough or invalid')

  _fullValidationOfResponse: ->
    # @_checkMatchingAccount() unless @ticket.type() == 'webchat'
    # @_checkEmptySocialAccount() unless @ticket.isReclameAqui() || @ticket.type() == 'webchat'
    try
      @editor.update() if @ticket.isEmail()
      @_checkValidForwardRecipients() if @action == 'forward'
      @_checkValidResponse()
      true
    catch error
      swal
        title: error.message
        type: 'warning'
      false

  onOperatorIsTyping: ->
    if @ticket.isWebchat() && (!@isTyping)
      @isTyping = true;
      setTimeout (=> @isTyping = false), 4000
      @ticket.operatorIsTyping()

  onClickReply: (event) ->
    @_keepCustomerSessionAlive()
    if @ticket.isWebchat()
      event.preventDefault()
      @replyWebchat(false)
    else
      return unless @_canReply()
      ticketType = @ticket.type()
      if ticketType in new_actions_strategy_types
        event.preventDefault()
        @replyTicketAction(ticketType)
      else
        @onSendResponse(event, @_doResponse) if @_fullValidationOfResponse()

  onClickReplyAndClose: (event) ->
    @_keepCustomerSessionAlive()
    return unless @_canReply()
    ticketType = @ticket.type()
    if ticketType in new_actions_strategy_types
      event.preventDefault()
      @replyAndCloseTicketAction(ticketType)
    else
      if @_fullValidationOfResponse()
        @_warnTicketTabWillClose(@_closeDictionaryForSwal(),() =>
          @onSendResponse(event, @_doResponse, {chained_action: 'close'})
        )

  _closeDictionaryForSwal: =>
    title: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.for_reply_and_close')
    text: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.description')
    confirmButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.confirm')
    cancelButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.cancel')

  _warnTicketTabWillClose: (textDictionary, callback) =>
    swal
      title: textDictionary.title
      text: textDictionary.text
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: textDictionary.confirmButtonText
      cancelButtonText: textDictionary.cancelButtonText
      closeOnConfirm: true
      callback

  onClickReplyAndChangeToPending: (event) ->
    @_keepCustomerSessionAlive()
    return unless @_canReply()
    ticketType = @ticket.type()
    event.preventDefault()
    @replyAndChangeToPendingAction(ticketType, event)

  _pendingDictionaryForSwal: =>
    title: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.for_reply_and_pending')
    text: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.description')
    confirmButtonText: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.confirm')
    cancelButtonText: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.cancel')

  replyAndChangeToPendingAction:(service_code, event) =>
    @_reloadEditor() if @ticket.isEmail()
    response = @_responseTextArea().val()
    if @hasEnoughData(response)
      if @_fullValidationOfResponse()
        @_warnTicketTabWillClose(@_pendingDictionaryForSwal(), () =>
          @_triggerDisableChangeToPendingButton()
          if @_shouldUseNewFormat(service_code)
            @_replyAndChangeToPendingNewFormat(service_code)
          else
            @_replyAndChangeToPendingOldFormat(service_code, event)
        )
    else
      swal(title: "#{I18n.t('customer.dashboard.conversations.details.response.empty')}", type: "warning")

  actionsAvailables: ->
    interaction = @_getInteractionToResponse()
    if _.isEmpty(interaction.get('available_reply_visibility'))
      swal
        title: I18n.t("customer.dashboard.errors.could_not_reply_over_this_message")
        type: 'warning'
      message = "Interaction can't be responded, no actions allowed for #{@ticket.subType()} #{JSON.stringify(interaction)}"
      jsLogger.fatal(message)
      return false
    true

  onSendResponse: (event, operation, options = {}) =>
    event.preventDefault()
    if @last_execution && (@last_execution + 2500) > new Date().getTime()
      console.log("Response debounced")
      return
    @last_execution = new Date().getTime()
    try
      return if @_responseTextArea().attr('disabled') && !@hasAttachment() && !@hasSticker()
      response = @_responseTextArea().val()
      action = @_getActiveButtonFrom(@$el.find('.btn_send_response'))

      responseAction = action.val() || 'public'
      operationPromise = operation(response, responseAction, options)
      operationPromise.done((response) =>
        return unless response.success
        @_closeTicketTab() if options.chained_action == 'close'
        @attachment.restoreDefaultAttachments(@_getInteractionToResponse()) if @action == 'forward'
      ).fail((response) =>
        try
          if response?.status == 413
            showError(I18n.t('customer.dashboard.errors.file_too_large'))
          else
            @trigger('validations:failed', response.responseJSON, response.skipAttributesErrorDetail)
        catch error
          jsLogger.fatal("Reply failure handler threw: #{error.message}")
          showError(I18n.t('generic_error_message'))
        finally
          @_enableResponse()
      )
    catch error
      #ISSUE: If there is a modal shown and it is confirmed, then the other modals will not be shown
      swal
        title: error.message
        type: 'warning'
    false

  hasSticker: ->
    false

  _reloadEditor:=>
    @editor.update()

  _triggerDisableChangeToPendingButton:=>
    Backbone.trigger('reply:disable-change-to-pending-button')

  _triggerReRenderPendingButton:=>
    Backbone.trigger('reply:reply-failed')

  _shouldUseNewFormat:(service_code)=>
    service_code in new_actions_strategy_types

  _replyAndChangeToPendingNewFormat:(service_code)=>
    return @replyWebchat(true) if @ticket.isWebchat()
    @ticket.replyTicketAction(service_code, @_paramsToResponse(@_responseTextArea().val(), {}, 'public'), {
      error: (response) =>
        @_handleResponseError(response)
        @$el.find('#response').attr('disabled', false)
      success:(response) =>
        @_sendTicketToPending(response)
    })

  _sendTicketToPending: (response) =>
    @_updateInteractionsCount(1)
    @ticket.ticketPendig(
      error: (response) =>
        @_handleResponseError(response)
      success: (response) =>
        response.conversation.status = 'Pending'
        @_handleResponseSuccess(response)
    )

  _replyAndChangeToPendingOldFormat:(service_code, event)=>
    @onSendResponse(event, @_doResponse, {callbacks: @_changeToPendingCallback()})

  _changeToPendingCallback:()=>
    success:(response) =>
      @changeToPending()
    error:(response)=>
      @_triggerReRenderPendingButton()

  changeToPending:=>
    @ticket.ticketPendig(
      error:(response) =>
        @_triggerReRenderPendingButton()
      success:(response) =>
        @_closeTicketTab()
    , {'after_response':true})


  _closeTicketTab: =>
    @trigger('ticket:tab:closeRequired')

  _doResponse: (response, action, options = {}) =>
    # TODO hack to respond to youtube videos until they are imported
    options.respond_to_parent = (@ticket.type() == 'youtube') && @options.mainResponse

    unless @checkAction(action)
      showError('Please check privacy selector')
      return

    if action == 'public'
      responsePromise = @ticket.publicResponseWithCallback(
        @_paramsToResponse(response, options, action),
        options.callbacks
      )
    else
      responsePromise = @ticket.privateResponseWithCallback(
        @_paramsToResponse(response, options, action),
        options.callbacks
      )

    @_disableResponse()
    responsePromise

  _doScheduleResponse: (response, action, options = {}) =>
    # TODO hack to respond to youtube videos until they are imported
    options.respond_to_parent = (@ticket.type() == 'youtube') && @options.mainResponse

    unless @checkAction(action)
      showError('Please check privacy selector')
      return

    callbacks = options.callbacks
    delete options.callbacks
    responsePromise = @ticket.scheduleResponse(@_paramsToResponse(response, options, action), callbacks)
    @_disableResponse()
    responsePromise

  checkAction: (action) ->
    if @ticket.type() in ['twitter']
      @$el.find(".btn_send_response[value=#{action}]").hasClass('active')
    else
      true

  hasEnoughData: (response) =>
    return true if @action == 'forward'
    (@hasText(response) && !@_responseTextArea().attr('disabled')) || @hasAttachment()

  hasText: (response) ->
    response.trim() != ''

  hasAttachment: =>
    @attachment && !_.isEmpty(@attachment.allFiles())

  onSendResponseAndClose: (event) =>
    @onSendResponse(event, chained_action: 'close')

  _paramsToResponse: (response, options, privacy) ->
    params =
      conversation_id: @ticket.get('id'),
      response: response,
      visibility: privacy,
      interaction_count: @ticket.get('dialogue').interaction_count,
      lock_version: @ticket.get('lock_version'),
      subject: @$el.find('.subject input').val()
      suggest_private_message: @$el.find('.suggest-private-message').is(':checked')
    params.social_account_id = @$el.find('#social_accounts').val() unless @emptySocialAccount()
    if @ticket.isWhatsapp()
      params.ticket_id = @ticket.get('id')
    else
      params.interaction_id = @_interactionIdToRespondTo(privacy) if @responseTo
    @_addExtraParams(params)
    _.extend(params, options)
    formData = new FormData()
    # TODO: Ver https://gitlab.keepcon.com/platform/self_service/commit/22dbef4a29461caadf0ab23ff6adc83bfaf6a920 y revisar si no hace falta modificar la condición
    @_addAttachments(formData)
    formData.append(k, v) for k, v of params
    formData

  _addExtraParams: (params) ->
    params

  _interactionIdToRespondTo: (privacy) ->
    isBrandContent = @ticket.getInteractionById(@responseTo).isBrandContent()
    return @responseTo unless @ticket.isByUser() && privacy == 'private' && isBrandContent

    firstPrivateNonBrandInteraction = @ticket.firstPrivateNonBrandInteraction()
    if firstPrivateNonBrandInteraction
      firstPrivateNonBrandInteraction.get('interaction_id')
    else
      @responseTo

  _updateInteractionsCount: (response)->
    @ticket.updateInteractionCount(1) unless response.skip_interactions_count_update

  _handleResponseSuccess: (response) ->
    @trigger('response:success', response)

  _handleResponseError: (response) ->
    # custom message or generic message
    @_handleStaleDialogueError(response)
    message = response.message || I18n.t('customer.dashboard.errors.could_not_reply_over_this_message')
    if response.error_type == 'not_following_user_error'
      @_handleFollow(false)
    if response.error_type == 'words_not_allowed'
      @_handleBlackListWordsError(response)
    showError(message)
    @_enableResponse()


  _handleStaleDialogueError: (response)=>
    if response.error_code == 'stale_dialogue'
      @_enableResponse()
      @_showStaleDialogueError(response)

  _showStaleDialogueError: (response)=>
    swal({
        title: I18n.t('customer.dashboard.conversations.stale_dialogue.message')
        type: 'warning'
        showCancelButton: true
        confirmButtonClass: 'btn-success'
        confirmButtonText: I18n.t('customer.dashboard.conversations.stale_dialogue.refresh')
        cancelButtonText: I18n.t('customer.dashboard.conversations.stale_dialogue.dismiss')
        closeOnConfirm: true
      }, => @ticket.updateWithJson(JSON.parse(response.updated_ticket))
    )

  _handleResponseStaleDialogue: ->
    @_enableResponse()

  _handleBlackListWordsError: (response) ->
    if response.success
      @$el.find('.reply-button.btn-group button').prop('disabled', false)
      return true

    words_not_allowed = _.uniq(response.words_not_allowed)

    swal_title = I18n.t('monitoring.reply_blacklist.not_allowed_title')
    swal_text = I18n.t('monitoring.reply_blacklist.not_allowed_text') + '<br>' + words_not_allowed.join(', ')
    swal({
      html: true,
      title: swal_title,
      text: swal_text,
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: false,
      confirmButtonClass: 'btn-primary customer-button',
      confirmButtonText: 'Entendido'
    }, ->)

  _addAttachments: (formData) ->
    if @attachment
      _.each(@attachment.allFiles(), (file) =>
        file_or_string = file
        file_or_string = JSON.stringify(file) if @ticket.isWebchat() || @ticket.isWhatsapp()
        formData.append('upload[]', file_or_string)
      )

  destroy: ->
    @remove()
    false

  showResponseTemplates: =>
    @eventAggregator.trigger('customer:dashboard:browseTemplateAnswers')
    new Customer.ResponseTemplateSelectView
      ticketId: @ticket.get('id')
      params: @_userTagsAndLabels()
      onSelect: (text) => @responseTemplateSelected(text)

  responseTemplateSelected: (text) ->
    dropOn = @_responseTextArea().get(0)
    insertTextAtCursor(dropOn, text)

  _userTagsAndLabels: ->
    #webchat has 2 subtypes but response_template_type type must be the same to both.
    if @options.mainResponse
      mainInteraction = @ticket.getInteractionForResponseTemplates()
      return [] unless mainInteraction
      labels: mainInteraction.labels()
      user: mainInteraction.name()
      username: mainInteraction.username()
      tags: mainInteraction.tags()
      typeForResponseTemplates: @fixTicketSubtypeForResponseTempleta(mainInteraction.subType())
    else
      labels: @options.labels
      user: @options.user
      username: @options.username
      tags: @options.tags
      typeForResponseTemplates: @fixTicketSubtypeForResponseTempleta(@ticket.subType())

  fixTicketSubtypeForResponseTempleta: (original_subtype) ->
    if @ticket.isWebchat()
      'webchat'
    else
      original_subtype

  focus: ->
    @_responseTextArea().focus()

  onExpand: =>
    $el = @$el.parent()
    $el.toggleClass('expanded-response shadow')
    if @options.mainResponse
      section = @$el.parents('#detail-parent')
      $el.toggleClass('span9') if section.hasClass('span7')
      $el.toggleClass('span12') if section.hasClass('span10')
      $el.siblings('#nano-detail').toggleClass('filler') if $el.hasClass('desc')

  updateTags: (tags) =>
    @options.tags = tags

  toggleSendButton: (enabled) ->
    @$el.find('.respond-button').prop('disabled', !enabled)

  reply: (event) ->

  forward: (event) ->

  _getInteractionToResponse: ->
    if @responseTo
      @ticket.getInteractionById(@responseTo)
    else
      @ticket.getInteractionToResponse()

  setSelectionRange: (input, selectionStart, selectionEnd) ->
    if input.setSelectionRange
      input.focus()
      input.setSelectionRange(selectionStart, selectionEnd)
    else if input.createTextRange
      range = input.createTextRange()
      range.collapse(true)
      range.moveEnd('character', selectionEnd)
      range.moveStart('character', selectionStart)
      range.select()

  setCaretToPos: (input, pos) ->
    try
      @setSelectionRange(input, pos, pos)
    catch error
      # sometimes this fails in firefox

  setCaretAtLastOfResponse: ->
    responseElement = @_responseTextArea()
    if responseElement.length > 0
      position = responseElement.val().split('\n')[0].length
      @setCaretToPos(responseElement.get(0), position)
      responseElement.get(0).focus()

  hasParticipants: (interactionId = null) ->
    @ticket.isTwitter() || @ticket.isInstagramPublic(interactionId)

  canAddAttachments: ->
    @ticket.type() == 'webchat' || @ticket.type() == 'whatsapp'

  canSendPictures: ->
    @ticket.subType() in ['tweet', 'direct-message']

  createResponseAttachment: ->
    @_renderAttachments()

  _setInputAsEmojiable: ->
    @_responseTextArea().emojiPicker(width: '280px', height: '300px', button: false)

  onToggleEmojis: =>
    @_keepCustomerSessionAlive()
    @_responseTextArea().emojiPicker('toggle')
    false

  shortenLinks: =>
    @_keepCustomerSessionAlive()
    @callShortenLinksApi(@_responseTextArea().val())
    false

  _showShortenerSpinner:->
    @$el.find("#shortener-button-icon").attr('hidden', true)
    @$el.find("#shortener-button-spinner").attr('hidden', false)

  _hideShortenerSpinner:->
    @$el.find("#shortener-button-spinner").attr('hidden', true)
    @$el.find("#shortener-button-icon").attr('hidden', false)

  callShortenLinksApi:(text) ->
    param = {}
    param['text'] = text
    @_disableResponseTextArea()
    @_showShortenerSpinner()
    $.ajax
      url: '/customer/url_shorteners'
      type: 'POST'
      data: param
      success: (response) =>
        @_responseTextArea().val(response["text"])
        @_updateCharacterCountAndLimit()
      complete: =>
        @_enableResponseTextArea()
        @_hideShortenerSpinner()


  renderTemplate: ->
    if @ticket.isWebchat()
      template = @templateWebchat
    else
      template = @template
    @$el.html(template(@_getParamsToRender()))
    @showOrHidePublicAndPrivateButtons()

  showOrHidePublicAndPrivateButtons: ->
    @$el.find('.btn-private-send').attr('disabled', false)
    @$el.find('.btn-public-send').attr('disabled', false)

    available_reply_visibility = @_getInteractionToResponse().get('available_reply_visibility')
    disable_private = !_.contains(available_reply_visibility, 'private')
    disable_public = !_.contains(available_reply_visibility, 'public')

    @$el.find('.btn-private-send').attr('disabled', disable_private)
    @$el.find('.btn-public-send').attr('disabled', disable_public)

    if _.contains(available_reply_visibility, 'public')
      @$el.find('.btn-public-send').addClass('active')
      @$el.find('.btn-private-send').removeClass('active')

  getInteractionToResponseLabels: =>
    @_getInteractionToResponse().get('labels')

  getInteractionToResponseSubtype: =>
    @_getInteractionToResponse().subType()

  addSignature: ->
    @_keepCustomerSessionAlive()
    unless @ticket.subType
      @_noSignatureTooltip()
      return

    singaturesCollection = @ticketView.getSignatures().signaturesFor(@getInteractionToResponseSubtype(), @getInteractionToResponseLabels(), (signature) =>
      if signature == ''
        @_noSignatureTooltip()
      else
        @_renderSignature(signature)
    )

  _renderSignature: (signature) ->
    responseElement = @_responseTextArea()
    position = responseElement[0].selectionEnd #+ positionOffset
    responseLength = responseElement[0].textLength
    initialText = responseElement.val().substring(0, position)
    finalText = responseElement.val().substring(position, responseLength)

    @responseText = "#{initialText}#{signature}#{finalText}"
    @renderResponseText()

  _shouldShowParticipants: ->
    @ticket.isInstagramPublic(@responseTo) && @ticket.hasActiveParticipants()

  renderResponseText: ->
    @_responseTextArea().val(@responseText)

  _noSignatureTooltip: ->
    @$el.find('#add-signature').tooltip('show').attr('data-original-title', I18n.t('customer.dashboard.conversations.details.response.no_signatures_available')).tooltip('fixTitle')
    @$el.find('#add-signature').tooltip('show')

  _handleFollow: (following) ->
    # following can be true or false
    value = if following then 'block' else 'none'
    @$el.parents('.form-container').css('display', value)

  openResponseSchedule: ->
    @_keepCustomerSessionAlive()
    if @_fullValidationOfResponse()
      @responseScheduleView = new Customer.Dashboard.ResponseScheduleView
        parentView: @
        responseSchedule: new Customer.ResponseSchedule()
      @$el.find('.response-schedule-container').html(@responseScheduleView.render().$el)
      @responseScheduleView.show()

    false

  replyTicketAction:(service_code) =>
    response = @$el.find('#response').val()
    if @hasEnoughData(response)
      @$el.find('#response').attr('disabled', true)
      @ticket.replyTicketAction(service_code, @_paramsToResponse(response, {}, 'public'), {
        error: (response) =>
          @_handleResponseError(response)
        success: (response) =>
          @_updateInteractionsCount(response)
          @_handleResponseSuccess(response)
      })
    else
      swal(title: "#{I18n.t('customer.dashboard.conversations.details.response.empty')}", type: "warning")

  replyAndCloseTicketAction:(service_code) =>
    response = @$el.find('#response').val()
    if @hasEnoughData(response)
      @_warnTicketTabWillClose(@_closeDictionaryForSwal(), () =>
        @$el.find('#response').attr('disabled', true)
        @ticket.replyTicketAction(service_code, @_paramsToResponse(response, {}, 'public'), {
          error: (response) =>
            @_handleResponseError(response)
            @$el.find('#response').attr('disabled', false)
          success:(response) =>
            @_updateInteractionsCount(1)
            @ticket.ticketClose(
              error: =>
                @_handleResponseError(response)
              success: =>
                response.conversation.status = "Closed"
                @_handleResponseSuccess(response)
            )
        })
      )
    else
      swal(title: "#{I18n.t('customer.dashboard.conversations.details.response.empty')}", type: "warning")

  saveResponseSchedule: (event, responseSchedule, callbacks) ->
    if @_fullValidationOfResponse()
      @onSendResponse(event, @_doScheduleResponse, {
        schedule: JSON.stringify(responseSchedule.toJSON()),
        callbacks: callbacks
      })

  replyWebchat: (toPending) ->
    response = @$el.find('#response').val()
    if @hasEnoughData(response)
      @$el.find('#response').attr('disabled', true)
      @$el.find('.send_response').attr('disabled', true)
      @ticket.replyWebchat(@_paramsToResponse(response, {}, 'public'), {
        success: (response) =>
          @changeToPending() if toPending
        error: (response) =>
          @$el.find('#response').attr('disabled', false)
          @$el.find('.send_response').attr('disabled', false)
          @_handleResponseError(response)
      })
    else
      swal(title: "#{I18n.t('customer.dashboard.conversations.details.response.empty')}", type: "warning")

  closeWebchat: () =>
    swal_title = I18n.t('customer.dashboard.conversations.webchat_messages.close_webchat_action')
    swal_text = ""
    swal( {
      html: true,
      title: swal_title,
      text: swal_text,
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonClass: 'btn-primary customer-button',
      confirmButtonText: I18n.t('customer.dashboard.conversations.webchat_messages.close_webchat_action_ok')
      cancelButtonClass: 'btn-danger customer-button',
      cancelButtonText: I18n.t('customer.dashboard.conversations.webchat_messages.close_webchat_action_cancel')
    }, (isConfirm) =>
      if isConfirm
        @doCloseWebchat()
    )

  doCloseWebchat: () =>
    $buttons = @$el.find('.response-btn').prop('disabled', true)
    @ticket.closeWebchat({ticket_id: @ticket.get('id'), webchat_id: @ticket.get('thread_keys')[0]}, {
      error: =>
        $buttons.prop('disabled', false)
        showError I18n.t('generic_error_message')
    })

  saveResponseSchedule: (event, responseSchedule, callbacks) ->
    if @_fullValidationOfResponse()
      @onSendResponse(event, @_doScheduleResponse, {
        schedule: JSON.stringify(responseSchedule.toJSON()),
        callbacks: callbacks
      })

  onResponseDisabled: =>
    @trigger('response:destroy')
    false

  _responseTextArea: ->
    @$el.find('#response')

  _enableResponseTextArea: ->
    @_responseTextArea().attr('disabled', false)

  _disableResponseTextArea: ->
    @_responseTextArea().attr('disabled', true)

  _responseButtonsGroup: ->
    @$el.find('#response-btn-group')

  _enableResponseButtons: ->
    buttonGroup = @_responseButtonsGroup()
    buttonGroup.find('button').attr('disabled', false)

  _disableResponseButtons: ->
    buttonGroup = @_responseButtonsGroup()
    buttonGroup.removeClass('open')
    buttonGroup.find('button').attr('disabled', true)

  _responseSpinner: ->
    @_responseButtonsGroup().find('#response-spinner')

  _hideResponseSpinner: ->
    @_responseSpinner().attr('hidden', true)

  _showResponseSpinner: ->
    @_responseSpinner().attr('hidden', false)

  _enableResponse: ->
    @_enableResponseTextArea()
    @_enableResponseButtons()
    @_hideResponseSpinner()

  _disableResponse: ->
    @_disableResponseTextArea()
    @_disableResponseButtons()
    @_showResponseSpinner()

  _disablePredefinedResponseButton: ->
    @$el.find("#predefined-answers-btn").attr('disabled', true)

  _enablePredefinedResponseButton: ->
    @$el.find("#predefined-answers-btn").attr('disabled', false)

  _disableExpandResponseButton: ->
    @$el.find("#expand-response-btn").attr('disabled', true)

  _enableExpandResponseButton: ->
    @$el.find("#expand-response-btn").attr('disabled', false)

  _disableEmojiPicker: ->
    @$el.find(".add_emoji").find(".fa-smile-o").addClass('disabled')
    @$el.off('click', '.add_emoji');

  _enableEmojiPicker: ->
    @$el.find(".add_emoji").find(".fa-smile-o").removeClass('disabled')
    @delegateEvents()

  _disableLinkShortener: ->
    @$el.find(".shorten_links").find(".fa-link").addClass('disabled')
    @$el.off('click', '.shorten_links');

  _enableLinkShortener: ->
    @$el.find(".shorten_links").find(".fa-link").removeClass('disabled')
    @delegateEvents()

  showIsTyping: ->
    @$el.find('#istyping-container').show(300)
    if @hide_is_typing_timeout
      clearTimeout @hide_is_typing_timeout
    @hide_is_typing_timeout = setTimeout @hideIsTyping, 6000

  hideIsTyping: =>
    @$el.find('#istyping-container').hide(300)

  _initialResponseTextWithSignature: (responseText = '') ->
    @ticketView.getSignatures()
      .signaturesForInitialResponse(@getInteractionToResponseSubtype(), @getInteractionToResponseLabels(),
      (signature) -> responseText = responseText.concat(signature)
    )
    responseText

  removeResponseBox: ->
    @.remove()
    @.unbind()

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _canReply: ->
    @actionsAvailables()
